<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <!--Viewing-->
            <div class="row">
              <div class="mobileDeviceViewing col-md-5" v-show="!isEditing">
                <div class="form-group">
                  <p style="font-size:35px">{{workflow.name}}</p>
                  <p>{{workflow.description}}</p>
                  <p>{{workflow.active == true ? 'Active' : 'Inactive'}}</p>
                  <p v-show="!workflow.ranger">{{workflow.critical == false ? 'Non Critical' : 'Critical'}}</p>
                  <p v-show="!workflow.ranger">{{workflow.endtimebased == false ? 'Start Time Based' : 'End Time Based'}}</p>
                  <p v-show="!workflow.ranger">Schedule: {{workflow.schedule}} Minutes</p>
                  <p v-show="!workflow.ranger">Warn Before: {{workflow.warnBefore}} Minutes</p>
                  <p>Last Completed: {{filteredData.lastcompleted}}</p>
                  <p v-show="!workflow.ranger">Next Due: {{filteredData.nextdue}}</p>
                  <br>
                  <!-- <data-table :data="devices" :columns="gridColumns" :filter-key="searchQuery"></data-table>
                  <br> -->
                  <button v-if="org['curOrg']['role'] == '1' || org['curOrg']['role'] == '2' || org['curOrg']['role'] == 99" v-on:click="edit" type="button" class="btn  btn-default form-group">Edit</button>
                </div>
              </div>
              <!--Editing-->
              <div class="mobileDeviceEditing col-md-5" v-show="isEditing && !workflow.ranger">
                <active-form-checkbox label="Active" name="active" v-model="workflowEdit.active"></active-form-checkbox>                
                <critical-form-checkbox label="Critical" name="critical" v-model="workflowEdit.critical"></critical-form-checkbox> 
                <endtimebased-form-checkbox label="End Time Based" name="endtimebased" v-model="workflowEdit.endtimebased"></endtimebased-form-checkbox>       

                <br>                
                <form-text styler="font-size:35px" ref="name" label="Name" name="name" v-model="workflowEdit.name" validation="required"></form-text>
                <form-textarea label="Description" name="description" v-model="workflowEdit.description"></form-textarea>
                <form-textnumber ref="schedule" label="Schedule" name="schedule" v-model="workflowEdit.schedule" validation="required"></form-textnumber>
                <form-textnumber ref="warnbefore" label="Warn Before" name="warnbefore" v-model="workflowEdit.warnBefore" validation="numeric"></form-textnumber>
                <!-- <div class="form-group">
                  <v-select placeholder="Assigned Devices" multiple :options="allDevices" label="name" name="users" :value.sync="devicesEdit"></v-select>
                </div>   --> 
                <br>          
                <div class="form-group">
                  <button v-on:click="cancelEdit" type="button" class="btn  btn-default">Cancel</button>
                  <button v-on:click="submitEdit" type="button" class="btn  btn-success">Submit</button>
                </div>
              </div>
              <!--Editing and Ranger-->
              <div class="mobileDeviceEditing col-md-5" v-show="isEditing && workflow.ranger">
                <active-form-checkbox label="Active" name="active" v-model="workflowEdit.active"></active-form-checkbox>                
                <div class="form-group">
                  <p style="font-size:35px">{{workflow.name}}</p>
                  <p>{{workflow.description}}</p>
                  <p>Last Completed: {{filteredData.lastcompleted}}</p>
                  <br>          
                  <div class="form-group">
                    <button v-on:click="cancelEdit" type="button" class="btn  btn-default">Cancel</button>
                    <button v-on:click="submitEdit" type="button" class="btn  btn-success">Submit</button>
                  </div>
                </div>
              </div>
              <div class="col-md-5 offset-md-1" v-show="!workflow.ranger">
                <h5>Tasks</h5>
                <p v-show="isEditing">* Tasks cannot be edited after creation.</p>

                <div v-if="org['curOrg']['role'] == 99">
                  <button v-on:click="tasksJsonView = true" type="button" v-if="!tasksJsonView" class="btn btn-default">JSON View</button>
                  <button v-on:click="tasksJsonView = false" type="button" v-else class="btn btn-default">Normal View</button>
                </div>
                <br>

                <br>

                <p>{{tasks.length - 1}} Tasks</p>

                <div v-if="!tasksJsonView">
                  <div class="list-group" v-for="task in tasks">
                    <div class = "list-group-item" v-for="element in task">
                      <div v-if="element.name == 'Location Tag'">
                        <div class="d-flex w-100 justify-content-between">
                          <p style="font-size:15px">{{element.name}}</p>
                          <!--<i v-on:click="deleteTask(element)" style="font-size:15px;color:red" class="ion ion-ios-trash"></i>-->
                        </div>
                        <small>Speak Text: {{element.speak}}</small>
                        <br>
                        <small class="">Tag Name: {{element.description}}</small>
                      </div>
                      <div v-else-if="element.name == 'Input'">
                        <div class="d-flex w-100 justify-content-between">
                          <p style="font-size:15px">{{element.name}}</p>
                          <!--<i v-on:click="deleteTask(element)" style="font-size:15px;color:red" class="ion ion-ios-trash"></i>-->
                        </div>
                        <small>Type: {{inputTypes.find(function(inputType){return inputType['.key'] == element.type})['name']}}</small>
                        <br>
                        <small class="">Name: {{element.description}}</small>
                      </div>
                      <div v-else-if="element.name == 'Temperature'">
                        <div class="d-flex w-100 justify-content-between">
                          <p style="font-size:15px">{{element.name}}</p>
                          <!--<i v-on:click="deleteTask(element)" style="font-size:15px;color:red" class="ion ion-ios-trash"></i>-->
                        </div>
                        <small class="">Name: {{element.description}}</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <pre>{{ tasks | pretty }}</pre>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div><!-- /.col-md-12 -->
      </div><!-- /.col-md-3 -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../../elements/Form/FormText'
import ActiveFormCheckbox from '../../elements/Form/ActiveFormCheckbox'
import CriticalFormCheckbox from '../../elements/Form/CriticalFormCheckbox'
import EndTimeBasedFormCheckbox from '../../elements/Form/EndTimeBasedFormCheckbox'
import FormTextNumber from '../../elements/Form/FormTextNumber'
import FormTextArea from '../../elements/Form/FormTextArea'
import database from '../../webmaster/Database/database'
import DataTable from './WorkflowDetailDevicesTable'
import vSelect from 'vue-select'
import store from '../../webmaster/Store/vuex'

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'workflowdetail',
  components:{
    'form-text':FormText,
    'data-table':DataTable,
    vSelect,
    'form-textarea':FormTextArea,
    'form-textnumber':FormTextNumber,
    'active-form-checkbox':ActiveFormCheckbox,
    'critical-form-checkbox':CriticalFormCheckbox,
    'endtimebased-form-checkbox':EndTimeBasedFormCheckbox,
  },
  data () {
    return {
      org: store.state.usermain,
      workflow: {
        name: '',
        active: true,
        critical: true,
        endtimebased: true,
        description: '',
        schedule: '',
        warnBefore: '',
      },
      workflowEdit: {
        name: '',
        active: true,
        critical: true,
        endtimebased: true,
        description: '',
        schedule: '',
        warnBefore: '',
      },
      tasks:[],
      devices: [],
      devicesEdit: [],
      isEditing: false,
      searchQuery: '',
      gridColumns: ["Devices"],
      allDevices: [],
      tasksJsonView: false,

      inputTypes: [{'name': "Number", '.key': "number"}, {'name': "Text", '.key': "text"}, {'name': "True/False", '.key': "bool"}],
    }
  },
  created:function(){
    this.fetchAll()
  },
  methods: {
    edit: function(){
      this.isEditing = true;
    },
    cancelEdit: function(){
      this.isEditing = false;
    },
    fetchAll:function(){
      this.fetchWorkflow()
      //this.fetchDevices()
      //this.fetchAllDevices()
    },
    fetchWorkflow: function(){
      this.$bindAsObject('workflow', database.getRef('/orgs/' + this.$store.state.usermain.curOrg.id + '/meta_workflows/' + this.$route.params.id), null, function(){
        this.workflowEdit = Object.assign({}, this.workflowEdit, this.workflow);

        if (this.workflow.tasks != null) {
          this.tasks = this.workflow.tasks;
        }
      });
    },
    fetchDevices:function(){
      var self = this
      var ref = '/orgs/' + this.$store.state.usermain.curOrg.id + '/workflows/' + this.$route.params.id + '/devices'
      const workflowDevices = database.getRef(ref)
      workflowDevices.once('value').then(snap => {
        let deviceKeys = Object.keys(snap.val());
        self.devices = []
        deviceKeys.forEach(key => {
          var deviceRef = '/orgs/' + this.$store.state.usermain.curOrg.id + '/devices/' + key
          const device = database.getRef(deviceRef)
          device.once('value').then(snapUser => {
            self.devices.push({
              ['.key']: key,
              name: snapUser.val().name
            })
          });
        });
        self.devicesEdit = self.devices
      });
    },
    fetchAllDevices:function(){
      //Get all users
      var ref = '/orgs/' + this.$store.state.usermain.curOrg.id + '/devices'
      this.$bindAsArray('allDevices', database.getRef(ref).orderByChild('type').equalTo('Mobile Device'));
    },
    submitEdit: function(e){
      e.preventDefault()
      let promises = [];
      var self = this;
      for (let child in this.$refs) promises.push(this.$refs[child].$validator.validateAll());
      Promise.all(promises).then(this.$validator.validateAll()).then(() => { 
        var workflowDevices = {}
        for (var user in self.devicesEdit) {
            var obj = self.devicesEdit[user];
            workflowDevices[obj['.key']] ={
              empty: "empty"
            }
        }
        var curOrgId = self.$store.state.usermain.curOrg.id
        var updates = {};
        updates['/orgs/' + curOrgId + '/workflows/' + this.$route.params.id + '/name'] = self.workflowEdit.name;
        updates['/orgs/' + curOrgId + '/workflows/' + this.$route.params.id + '/description'] = self.workflowEdit.description;
        updates['/orgs/' + curOrgId + '/workflows/' + this.$route.params.id + '/schedule'] = self.workflowEdit.schedule;
        updates['/orgs/' + curOrgId + '/workflows/' + this.$route.params.id + '/warnBefore'] = self.workflowEdit.warnBefore;
        updates['/orgs/' + curOrgId + '/workflows/' + this.$route.params.id + '/active'] = self.workflowEdit.active;
        updates['/orgs/' + curOrgId + '/workflows/' + this.$route.params.id + '/critical'] = self.workflowEdit.critical;
        updates['/orgs/' + curOrgId + '/workflows/' + this.$route.params.id + '/endtimebased'] = self.workflowEdit.endtimebased;
        updates['/orgs/' + curOrgId + '/workflows/' + this.$route.params.id + '/devices'] = workflowDevices;
        
        updates['/orgs/' + curOrgId + '/meta_workflows/' + this.$route.params.id + '/name'] = self.workflowEdit.name;
        updates['/orgs/' + curOrgId + '/meta_workflows/' + this.$route.params.id + '/description'] = self.workflowEdit.description;
        updates['/orgs/' + curOrgId + '/meta_workflows/' + this.$route.params.id + '/schedule'] = self.workflowEdit.schedule;
        updates['/orgs/' + curOrgId + '/meta_workflows/' + this.$route.params.id + '/warnBefore'] = self.workflowEdit.warnBefore;
        updates['/orgs/' + curOrgId + '/meta_workflows/' + this.$route.params.id + '/active'] = self.workflowEdit.active;
        updates['/orgs/' + curOrgId + '/meta_workflows/' + this.$route.params.id + '/critical'] = self.workflowEdit.critical;
        updates['/orgs/' + curOrgId + '/meta_workflows/' + this.$route.params.id + '/endtimebased'] = self.workflowEdit.endtimebased;
        updates['/orgs/' + curOrgId + '/meta_workflows/' + this.$route.params.id + '/devices'] = workflowDevices;
        database.getDb().ref().update(updates, function(){
          self.isEditing = false
          self.fetchAll()
        });
      }, () => {});
    }
  },
  computed: {
    filteredData:function(){
      var data = this.workflow

      var pubDate = new Date(data['nextdue']*1000);
      var weekday=new Array("Sun","Mon","Tue","Wed","Thu","Fri","Sat");
      var monthname=new Array("Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec");
      var hours = pubDate.getHours();
      var minutes = pubDate.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var time = hours + ':' + minutes + ' ' + ampm;
      var formattedDate = weekday[pubDate.getDay()] + ' ' 
                + monthname[pubDate.getMonth()] + ' ' 
                + pubDate.getDate() + ', ' 
                + pubDate.getFullYear() + ' at ' 
                + time

      data['nextdue'] = formattedDate

      if (data['lastcompleted'] != ''){
        var pubDate = new Date(data['lastcompleted']*1000);
        var weekday=new Array("Sun","Mon","Tue","Wed","Thu","Fri","Sat");
        var monthname=new Array("Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec");
        var hours = pubDate.getHours();
        var minutes = pubDate.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var time = hours + ':' + minutes + ' ' + ampm;
        var formattedDate = weekday[pubDate.getDay()] + ' ' 
                  + monthname[pubDate.getMonth()] + ' ' 
                  + pubDate.getDate() + ', ' 
                  + pubDate.getFullYear() + ' at ' 
                  + time

        data['lastcompleted'] = formattedDate
      }else{
        data['lastcompleted'] = "Never"
      }

      return data
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// WorkflowDetail.vue?56912d32